export const PRIMARY_DOCUMENTATION = {
  EDO: 'edo',
  PAPER: 'paper',
  ABSENT: 'absent',
} as const;

export const PRIMARY_DOCUMENTATION_VALUES = Object.values(
  PRIMARY_DOCUMENTATION,
);

export const PRIMARY_DOCUMENTATION_LABELS = {
  [PRIMARY_DOCUMENTATION.EDO]: 'Первичная документация по ЭДО',
  [PRIMARY_DOCUMENTATION.PAPER]: 'Первичная документация на бумаге',
  [PRIMARY_DOCUMENTATION.ABSENT]: 'Первичная документация отсутствовала',
} as const;
